import { FeatureName, useIsFeatureEnabled } from '@gripp/shared-logic';
import { SlideLayout } from '@gripp/shared-ui';
import { ProductsOld } from './products-old';
import { ProductsComponent } from './productsComponent';
import { ProductsFilters } from './productsFilters';

export const Products = () => {
  const isCropCircleEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );

  if (isCropCircleEnabled) {
    return <ProductsBase />;
  }

  return <ProductsOld />;
};

const ProductsBase = () => {
  return (
    <SlideLayout
      leftColumn={{
        title: 'product.list.products',
        mainComponent: <ProductsComponent />,
        headerComponent: <ProductsFilters />,
      }}
    />
  );
};
